<template>
    <div>
        <headerNotice routerName="库存预警"></headerNotice>
        <!-- 搜索栏 -->
        <div class="searchBox">
            <el-row :gutter="24">
                <!-- 搜索框 -->
                <el-col :span="5" :offset="0">
                    <el-input placeholder="请输入商品/规格/规格编号" v-model="serachForm.keyword">
                        <el-button slot="append" icon="el-icon-search" @click="serachIt"></el-button>
                    </el-input>
                </el-col>
                <!-- 分类搜索 -->
                <el-col :span="4" :offset="0">
                    <el-cascader change-on-select :options="cateList" :props="cateProps" @change="cateSearch"></el-cascader>
                </el-col>
                <!-- 标签搜索 -->
                <el-col :span="4" :offset="0">
                    <el-select
                        v-model="serachForm.labelID"
                        @change="tagSearch"
                        placeholder="请选择商品标签"
                    >
                        <el-option label="全部" :value="0"></el-option>
                        <el-option
                            v-for="item in labelList"
                            :key="item.labelID"
                            :label="item.labelName"
                            :value="item.labelID"
                        ></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </div>

        <!-- 数据表格 -->
        <div class="dataTable" v-loading="loading">
            <el-table
                class="tableBox"
                :data="itemsList"
                style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}"
            >
                <el-table-column prop="title" label="商品名称"></el-table-column>
                <el-table-column align="center" label="商品图片" width="120">
                    <template slot-scope="scope">
                        <img :src="baseUrl+scope.row.imgUrl" alt width="100" height="100">
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="itemCode" label="商品编号" width="150" sortable></el-table-column>
                <el-table-column align="center" prop="propName" label="规格" width="200"></el-table-column>
                <el-table-column align="center" prop="propCode" label="规格编号" width="150" sortable></el-table-column>
                <el-table-column align="center" prop="unit" label="单位" width="120"></el-table-column>
                <el-table-column align="center" prop="stock" label="可用库存" width="150" sortable></el-table-column>
                <el-table-column align="center" prop="realStock" label="系统库存" width="150" sortable></el-table-column>
                <el-table-column
                    align="center"
                    prop="stockWaring"
                    label="库存预警值"
                    width="150"
                    sortable
                ></el-table-column>
            </el-table>
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
      loading: false,
      baseUrl: this.$store.state.apiUrl,
      loading: true,
      totalCount: 0, //总数据条数
      maxResultCount: 10, //默认一页显示的个数,
      currentPage: 1,
      cateList: [], //所有分类数据
      cateProps: {
        value: "cateID",
        label: "cateName",
        children: "cates"
      },
      labelList: [], //所有变标签数据
      unitList: [], //所有单位数据
      brandList: [], //所有品牌数据
      itemsList: [], //商品列表主数据
      serachForm: {
        keyword: "", //搜索框
        labelID: null,
        cateID: null
      }
    };
  },
  components: {
    headerNotice
  },
  mounted() {
    this.getDatas({
      MaxResultCount: this.maxResultCount,
      Status: 2
    });
    //获取所有分类下拉
    this.getSelectDatas();
    this.getCates();
  },
  methods: {
    //获取列表数据
    getDatas(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminItem/GetStockWaringList",
        params: params,
        success(res) {
          self.itemsList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    //获取所有分类下拉
    getSelectDatas() {
      let self = this;
      //获取分类
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminItem/GetCLUBList",
        success(res) {
          // self.cateList = res.cateList;
          self.brandList = res.brandList;
          self.labelList = res.labelList;
          self.unitList = res.unitList;
        },
        fail(res) {}
      });
    },
    //获取所有分类下拉
    getCates() {
      let self = this;
      //获取分类
      $http.GET({
        url: this.$store.state.apiUrl + "/api/services/app/AdminCate/GetCate",
        success(res) {
          self.cateList = res;
          self.cateList.unshift({
            cateName: "全部",
            cateID: 0,
            id: 0,
            cates: [
              {
                cateName: "全部",
                cateID: 0,
                id: 0,
                cates: null
              }
            ]
          });
        },
        fail(res) {}
      });
    },
    //名字 编号等搜索
    serachIt() {
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        Keyword: this.serachForm.keyword
      });
      this.currentPage = 1;
    },
    //分类改变搜索
    cateSearch(val) {
      if (val.length == 2) {
        this.serachForm.cateID = val[1];
      } else {
        this.serachForm.cateID = val[0];
      }
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        skipCount: 0,
        CateID: this.serachForm.cateID,
        Status: 2
      });
    },
    //标签改变搜索
    tagSearch() {
      this.getDatas({
        MaxResultCount: this.maxResultCount,
        LabelID: this.serachForm.labelID
      });
      this.currentPage = 1;
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        MaxResultCount: val
      };
      this.getDatas(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      this.loading = true;
      let skipCount = (val - 1) * this.maxResultCount;
      let params = {
        SkipCount: skipCount,
        MaxResultCount: this.maxResultCount
      };
      this.getDatas(params);
    }
  }
};
</script>

<style lang='scss' scoped>
// 搜索栏
.searchBox {
  padding: 20px;
}
// 数据表格
.dataTable {
  .tableBox {
    border: 1px solid #c5c5c5;
  }
  padding: 20px;
  padding-bottom: 0;
}
</style>
